document.addEventListener("DOMContentLoaded", function () {
  let slides = document.querySelectorAll(".slide");
  let slideTag = document.querySelector(".slide-tag");
  let totalSlides = slides.length;
  let activeIndex = 0;
  let prevButton = document.getElementById("prevButton");
  let nextButton = document.getElementById("nextButton");

  let screenWidth, activeWidth, prevWidth, nextWidth;

  function updateButtonStates() {
    prevButton.disabled = activeIndex === 0;
    nextButton.disabled = activeIndex === totalSlides - 1;

    // Add visual feedback for disabled state
    prevButton.classList.toggle("opacity-50", activeIndex === 0);
    nextButton.classList.toggle("opacity-50", activeIndex === totalSlides - 1);
  }

  function resizeHandler() {
    screenWidth = window.innerWidth;

    if (screenWidth > 1024) {
      activeWidth = screenWidth * 0.59;
      prevWidth = screenWidth * 0.59;
      nextWidth = screenWidth * 0.32;
    } else {
      activeWidth = screenWidth * 0.8;
      prevWidth = screenWidth * 0.8;
      nextWidth = screenWidth * 0.8;
    }

    updateSlides();
  }

  function updateSlides() {
    slides.forEach((slide, index) => {
      let isActive = index === activeIndex;
      let zIndex;

      if (index < activeIndex) {
        zIndex = totalSlides - (activeIndex - index) - 1;
      } else if (index === activeIndex) {
        zIndex = totalSlides;
      } else {
        zIndex = totalSlides + (totalSlides - index);
      }

      let slideWidth =
        isActive || index < activeIndex ? activeWidth : nextWidth;

      let xOffset;
      if (index < activeIndex) {
        xOffset = 0;
      } else if (index === activeIndex) {
        xOffset = 0;
      } else {
        let prevActiveWidth = activeWidth;
        let prevSlidesWidth = (index - activeIndex - 1) * nextWidth;
        xOffset = prevActiveWidth + prevSlidesWidth;
      }

      gsap.to(slide, {
        x: xOffset,
        width: slideWidth,
        zIndex: zIndex,
        duration: 0.6,
        scrub: true,
        ease: "none",
      });

      if (isActive) {
        slide.classList.add("active");
        slideTag.textContent = slide.getAttribute("data-tag");
        document.querySelectorAll(".slide-content").forEach((content) => {
          content.classList.remove("active");
          if (content.getAttribute("data-slide-index") == index) {
            content.classList.add("active");
          }
        });
      } else {
        slide.classList.remove("active");
      }
    });
  }

  window.nextSlide = function () {
    if (activeIndex < totalSlides - 1) {
      activeIndex++;
      updateSlides();
      updateButtonStates();
    }
  };

  window.prevSlide = function () {
    if (activeIndex > 0) {
      activeIndex--;
      updateSlides();
      updateButtonStates();
    }
  };

  window.addEventListener("resize", resizeHandler);
  resizeHandler();
  updateButtonStates(); // Initialize button states
});
